<div id="legal">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">Legal Literacy Cell</h4>
                    <div class="card-body">
                        <p class="lead text-justify">
                            Under the Legal Literacy Cell, the College organizes various Awareness Programs, workshops,
                            talks, discussions (organized by DLSA) on legal issues related to :
                        </p>

                        <ul>
                            <li>
                                <p class="lead text-justify text-dark">Women rights</p>
                            </li>
                            <li>
                                <p class="lead text-justify text-dark">Consumer Protection</p>
                            </li>
                            <li>
                                <p class="lead text-justify text-dark">Issues of rights & responsibilities of the
                                    citizens</p>
                            </li>
                        </ul>

                        <div class="row">
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/1.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/2.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/3.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/4.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/5.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/6.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/7.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/8.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/9.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/10.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/11.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/litracy_cell/12.jpeg" alt="Legal Cell"
                                    class="img-fluid rounded h250">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <div id="legal">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">Legal Literacy Cell</h4>
                    <div class="card-body">
                        <p class="lead text-justify">Under the Legal Literacy Cell, the College organizes various Awareness Programs, workshops, talks, discussions (organized by DLSA) on legal issues related to : -  
                        </p>
                        <ul>
                            <li>
                                <p class="lead text-justify text-dark">Women rights</p>
                            </li>
                            <li>
                                <p class="lead text-justify text-dark">Consumer Protection</p>
                            </li>
                            <li>
                                <p class="lead text-justify text-dark">Issues of rights & responsibilities of the citizens
                                </p>
                            </li>
                        </ul>
                        <div class="row text-center">
                            <div class="col-12">
                                <img src="/assets/img/litracy_cell/1.jpeg" alt="Cell" class="img-fluid rounded">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/1.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/2.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/3.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/4.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/5.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/6.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/7.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/8.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/9.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/10.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/11.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/litracy_cell/12.jpeg" alt="Nss" class="img-fluid rounded">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->